export default __webpack_public_path__ + "static/media/carrot.588d98bf.jpg";